<template>
  <div id="tab1" class="t-color-content1 pdl-16 pdr-16 pdb-32">
    <div class="mgt-32"></div>
    <div class="pdt-50">
      <img
        src="images/reward/badge1.svg"
        alt=""
        class="d-block mgx-auto noDataImage"
      />
    </div>
    <div
      class="t-color-title t-subtitle3 t-center pdt-36 pdb-8 l-spacing48font-m"
    >
      {{$t('1709')}}
    </div>
    <div class="t-color-content1 t-body3 t-center l-spacing42 font-r">
      {{$t('1710')}}
    </div>
  </div>
</template>

<script>
/**
 * 데이터 없음 컴포넌트(no data Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  
};
</script>
<style scoped>
.noDataImage{
    width: 67px;
    height: 64px;
  }
</style>
